import React, { useState } from "react";
import {
  Box,
  Modal,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
  Divider,
  Collapse,
  Button,
  TextField,
} from "@mui/material";
import styles from "./CancellationSelectorStyle";
import { cancelShift } from "../../../../../../api/apiCall";
import { useAuth } from "../../../../../../auth/auth";

const CancellationModal = ({ open, onClose, data }: any) => {
  const {state} = useAuth();
  const [canceledBy, setCanceledBy] = useState("pace");
  const [lessThan, setLessThan] = useState("");
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setCanceledBy("pace");
    setLessThan("");
    onClose();
  };

  const handleSubmit = async () => {
    if (canceledBy === "pace") {
      handleClose();
      return;
    }

    const payload = {
      userJobId: data.userJobId,
      workerId: data.workerId,
      noticePeriod: canceledBy === "individual" ? Number(lessThan) : null,
      reason: reason,
    };

    await cancelShift(state.user?.token, payload);

    handleClose();
  };

  return (
    <Modal open={open} keepMounted={true}>
      <Box sx={styles.modal}>
        <Card sx={styles.card}>
          <CardContent>
            <Typography variant="h6" sx={styles.header}>
              Cancellation Details
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <FormControl fullWidth>
              <FormLabel sx={styles.label}>Canceled by</FormLabel>

              <RadioGroup
                row
                value={canceledBy}
                onChange={(e) => {
                  setCanceledBy(e.target.value);
                  if (e.target.value !== "individual") {
                    setLessThan("");
                  }
                }}
              >
                <FormControlLabel value="pace" control={<Radio />} label="Pace" />
                <FormControlLabel value="individual" control={<Radio />} label="Individual" />
              </RadioGroup>
            </FormControl>

            <Collapse in={canceledBy === "individual"}>
              <Box sx={styles.subSection}>
                <Typography variant="subtitle2" sx={styles.subHeader}>
                  Notice period
                </Typography>

                <FormControl>
                  <RadioGroup
                    value={lessThan}
                    onChange={(e) => setLessThan(e.target.value)}
                  >
                    <FormControlLabel value={0} control={<Radio />} label="Less than 24 hours" />
                    <FormControlLabel value={1} control={<Radio />} label="Less than 48 hours" />
                    <FormControlLabel value={2} control={<Radio />} label="More than 3 days" />
                    <FormControlLabel value={3} control={<Radio />} label="Excused (Valid reason)" />
                  </RadioGroup>
                </FormControl>

              </Box>
               <TextField
                  label="Notes"
                  multiline
                  rows={4}
                  fullWidth
                  sx={{ mt: 2 }}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Add additional details here..."
                />
            </Collapse>

            <Box sx={styles.actions}>
              <Button onClick={handleClose} color="inherit">
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={handleSubmit}
                style={{ boxShadow: "none" }}
                disabled={!canceledBy || (canceledBy === "individual" && !lessThan)}
              >
                Submit
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

export default CancellationModal;
